import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import {
  GridEmailLink,
  GridLocationLink,
  GridPhoneLink,
} from '@user/components/xGrid'
import {
  getFormattedAddress,
  updateEmailValueSearch,
  updatePhoneValueSearch,
} from '@sales-center/common'
import { ServiceLocation } from '@user/store/entityLocations'

export const locationSearchColumns: GridColDef[] = [
  {
    field: 'id',
    headerName: 'Location',
    sortable: false,
    renderCell: ({ row }) => (
      <GridLocationLink
        locationId={row.id}
        locationCode={row.number}
        variant="service"
      />
    ),
    align: 'center',
  },
  {
    field: 'branch',
    headerName: 'Branch',
    sortable: false,
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    valueGetter: ({ row }) => `${row.firstName} ${row.lastName}`,
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'company',
    headerName: 'Company',
    sortable: false,
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'address',
    headerName: 'Address',
    flex: 1,
    minWidth: 200,
    sortable: false,
    valueGetter: ({ row }) => row,
    valueFormatter: ({ value }) => {
      const {
        address: { address, address2, city, state, postalCode },
      } = value as ServiceLocation

      return getFormattedAddress(address, address2, city, state, postalCode)
    },
  },
  {
    field: 'phone',
    headerName: 'Phone',
    minWidth: 150,
    sortable: false,
    renderCell: ({ row }) => (
      <GridPhoneLink
        dataTestId={`phoneLink-${row.id}`}
        phone={updatePhoneValueSearch(row.phone ?? '')}
        ext={row.phoneExt ?? ''}
      />
    ),
  },
  {
    field: 'email',
    headerName: 'Email',
    sortable: false,
    renderCell: ({ row }) => (
      <GridEmailLink
        dataTestId={`phoneLink-${row.id}`}
        value={updateEmailValueSearch(row.email ?? '')}
      />
    ),
    flex: 1,
    minWidth: 200,
  },
]
